import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.number.constructor.js";
import Card from "../../models/Card";
export var setCards = function setCards(state, payload) {
  state.cards = payload.map(function (card) {
    return new Card(card);
  });
};
export var setDefault = function setDefault(state, cardId) {
  state.cards = state.cards.map(function (card) {
    return card.setDefault(card.id() === cardId);
  });
};
export var reset = function reset(state) {
  state.cards = null;
};
export var fixCard = function fixCard(state, payload) {
  state.cards = state.cards.map(function (card) {
    return card.setParams(payload);
  });
};
export var deleteCard = function deleteCard(state, cardId) {
  state.cards = state.cards.filter(function (card) {
    return card.id() !== Number(cardId);
  });
};